import React, { useState, useEffect } from "react";

// Component
import ToDoCardsGrid from "./components/ToDoCardsGrid";
import AddNewCardModal from "./components/AddNewCardModal";
import CardDetailsModal from "./components/CardDetailsModal";

function MyOverviewTab() {
  const [openModalPopUp, setOpenModalPopUp] = useState(false);
  const [openCardDetails, setOpenCardDetails] = useState(false);
  const [update, setUpdate] = useState(1);
  const [cardData, setCardData] = useState();

  return (
    <div className="space-y-4 mt-4">
      <div className="h-full w-full">
        <ToDoCardsGrid
          setCardData={setCardData}
          setOpenModalPopUp={setOpenModalPopUp}
          update={update}
          setUpdate={setUpdate}
          setOpenCardDetails={setOpenCardDetails}
        />
      </div>
      <AddNewCardModal
        openModalPopUp={openModalPopUp}
        setOpenModalPopUp={setOpenModalPopUp}
        setUpdate={setUpdate}
        update={update}
      />
      <CardDetailsModal
        cardData={cardData}
        openCardDetails={openCardDetails}
        setOpenCardDetails={setOpenCardDetails}
      />
    </div>
  );
}

export default MyOverviewTab;
